import React from 'react';
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import OurMarker from './OurMarker';
import { debounce, isEqual } from 'lodash';
import * as Tools from "../../helpers/Tools";
const defaultMarkerUrl = "../../../images/map-pin.svg";
const selectedMarkerUrl = "../../../images/map-pin-selected.svg";
const mapStyles = [
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#53575a"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#74ded4"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#e6eaee"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#53575a"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e6eaee"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape.natural.landcover",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#e6eaee"
            }
        ]
    },
    {
        "featureType": "landscape.natural.terrain",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#00c5b3"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#74ded4"
            }
        ]
    },
    {
        "featureType": "poi.attraction",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#74ded4"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#74ded4"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#53575a"
            }
        ]
    },
    {
        "featureType": "poi.government",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#74ded4"
            }
        ]
    },
    {
        "featureType": "poi.medical",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#d5dde4"
            }
        ]
    },
    {
        "featureType": "poi.medical",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#53575a"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#74ded4"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#53575a"
            }
        ]
    },
    {
        "featureType": "poi.place_of_worship",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#74ded4"
            }
        ]
    },
    {
        "featureType": "poi.place_of_worship",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#525659"
            }
        ]
    },
    {
        "featureType": "poi.school",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#e6eaee"
            }
        ]
    },
    {
        "featureType": "poi.school",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#53575a"
            }
        ]
    },
    {
        "featureType": "poi.sports_complex",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#74ded4"
            }
        ]
    },
    {
        "featureType": "poi.sports_complex",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#53575a"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fdfefe"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#f9dc90"
            }
        ]
    },
    {
        "featureType": "transit.station.airport",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#d5dde4"
            }
        ]
    },
    {
        "featureType": "transit.station.airport",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#53575a"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#00c1e0"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text",
        "stylers": [
            {
                "color": "#fafafb"
            }
        ]
    }
];

class GoogleMapMain extends React.Component {
    constructor(props) {
        super(props);
        
        const { bounds, myMarkers } = this.getMarkers(props);
        this.state = {
            myMarkers: myMarkers,
            activeMarker: null,
            selectedMarker: null,
            zoom: 10
        };
        this.searchHere = this.searchHere.bind(this);
        this.debounce = debounce(this.handleMapHeight.bind(this), 150, { trailing: true, leading: true, maxWait: 100 });
        this.onMapDragend = this.onMapDragend.bind(this);
        this.hideSearchHere = this.hideSearchHere.bind(this);
        this.showSearchHere = this.showSearchHere.bind(this);
        this.onZoomChanged = this.onZoomChanged.bind(this);        
    }

    componentDidMount() {
        this._isMounted = true;
        const { currentLatitude, currentLongitude, updateCurrentLocationZipCode } = this.props;
        if (currentLatitude && currentLongitude) {
            this.reverseGeocoding(currentLatitude, currentLongitude, updateCurrentLocationZipCode);
        }
        if (typeof window !== 'undefined' && this.props.searchHereButton) {
            window.addEventListener('scroll', this.debounce);
            window.addEventListener('resize', this.debounce);
        }        
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { filtersOpen, searchHereButton, list, isMappedArea, distance, radius, hideSearchHere, highlightSelectedItem, fitBounds } = this.props;
        const { activeMarker, myMarkers, zoom, selectedMarker, deselectedMarker, mappedAreaLocation, mapBounds } = this.state;

        if ((filtersOpen !== nextProps.filtersOpen)
            || (searchHereButton !== nextProps.searchHereButton)
            || (highlightSelectedItem !== nextProps.highlightSelectedItem)
            || !isEqual(nextProps.list, list)
            || (isMappedArea !== nextProps.isMappedArea)
            || (distance !== nextProps.distance)
            || (radius !== nextProps.radius)
            || (hideSearchHere !== nextProps.hideSearchHere)
            || !isEqual(mappedAreaLocation, nextState.mappedAreaLocation)
            || !isEqual(mapBounds, nextState.mapBounds)
            || !isEqual(activeMarker, nextState.activeMarker)
            || !isEqual(myMarkers, nextState.myMarkers)
            || zoom !== nextState.zoom
            || !isEqual(selectedMarker, nextState.selectedMarker)
            || !isEqual(deselectedMarker, nextState.deselectedMarker)            
            || (fitBounds !== nextProps.fitBounds)
        )

            return true;

        else
            return false;
    }

    componentDidUpdate(prevProps, prevState) {       
        const { list, filtersOpen } = this.props;            
        if (list !== null && !isEqual(prevProps.list, list)) {            
            const { bounds, myMarkers } = this.getMarkers(this.props);
            this.setState({
                myMarkers: myMarkers
            });
        }
        //If distance is changed and if its not a mapped area location then we have to apply zoom options.
        if (this.props.distance && prevProps.distance !== this.props.distance && (this.props.radius === null || (this.props.radius && this.props.radius.toLowerCase() !== "radius"))) {
            const requiredZoom = this.radiusToZoom(this.props.distance) > 14 ? 14 : this.radiusToZoom(this.props.distance);
            if (prevState.zoom !== requiredZoom) {
                this.setState({ zoom: requiredZoom }, () => {this.zoomSetByUser = false;});               
            }
        }
        if (prevProps.filtersOpen !== filtersOpen)
            this.handleMapHeight();
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (typeof window !== 'undefined' && this.props.searchHereButton) {
            window.removeEventListener('scroll', this.debounce);
            window.removeEventListener('resize', this.debounce);
        }
    }

    radiusToZoom(radius) {
        return Math.round(14 - Math.log(radius) / Math.LN2);
    }

    getMarkers = (props) => {
        const { list, getId, getLatitude, getLongitude, isMappedArea, radius, searchHereButton, fitBounds } = props;
        if (!this.props.google) return;
        const  mapBounds  = this.state && this.state.mapBounds;
        // if its a isMappedArea search then we not need to change the bounds, center and zoom level of map
        //const bounds = !isMappedArea || !mapBounds ? new this.props.google.maps.LatLngBounds() : mapBounds;
        const bounds = (!isMappedArea || (radius === null || (radius && radius.toLowerCase() !== "radius")) || !mapBounds) ? new this.props.google.maps.LatLngBounds() : mapBounds;

        const myMarkers = list && list.length > 0 ? list.map(item => {
            const id = getId(item);
            const point = { lat: getLatitude(item), lng: getLongitude(item) };
            bounds.extend(point);
            return (
                <OurMarker key={id} id={id} item={item} position={point}
                    icon={{ url: defaultMarkerUrl, anchor: new google.maps.Point(0, 42), scaledSize: new google.maps.Size(32, 42) }}
                    onClick={this.onMarkerClick}
                    onMouseover={this.onMarkerMouseover}
                    onMouseout={this.onMarkerMouseout}
                />
            );
        }) : null;

        // Bring the Markers in the center of the map only in case if there is no Search Here Click
        if ((!isMappedArea || (radius === null || (radius && radius.toLowerCase() !== "radius")) || !mapBounds)) {
            if (!bounds.equals(new this.props.google.maps.LatLngBounds()) && this.map) {
                this.zoomSetByUser = false;
                this.map.fitBounds(bounds);
            }
        }
        else if (this.map && mapBounds && searchHereButton && fitBounds) {
            this.zoomSetByUser = false;
            this.map.fitBounds(mapBounds);
        }
        
        return { bounds, myMarkers };
    }

    removeInlineStyle(element) {
        if (element && element.hasAttribute("style")) {
            element.removeAttribute("style");
        }
    }

    handleMapHeight() {
        if (!this.props.searchHereButton) return; // handle the mapHeight in FindCareResults and not in Pharmacy
        if (typeof window !== 'undefined' && !this.props.isVaccineSearch) {
            const tabContent = window.document.querySelectorAll('.find-care-results .results-list-scrollable');      
            const mapContent = window.document.querySelector('.find-care-results .find-care-google-map');   
            if (tabContent && mapContent) {
                const mobileWidth = 959;
                const windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
                const isIEorEdge = Tools.isBrowserIEOrEdge();
                if (windowWidth <= mobileWidth) {
                    //Converted foreach to for loop. NodeLists for IE11 support.
                    if (isIEorEdge) {
                        for (let tabctx = 0; tabctx < tabContent.length; tabctx++) {
                            this.removeInlineStyle(tabContent[tabctx]);
                        }
                    } else {
                         tabContent.forEach(item => {
                            this.removeInlineStyle(item); 
                         });
                    }
                    this.removeInlineStyle(mapContent);
                    return;
                }                
                const windowY = window.pageYOffset;
                const maxOffset = this.props.isVaccineSearch ? 50 : 180;
                let dynamicHeight = '';

                const findCareResultsTop = mapContent.getBoundingClientRect().top;                  
                let dynamicHeightOffset = findCareResultsTop - windowY;
                        
                if (dynamicHeightOffset > maxOffset) {
                    dynamicHeight = 'calc(100vh - ' + dynamicHeightOffset + 'px)'; 
                }
                if (isIEorEdge) {
                    for (let tabcnt = 0; tabcnt < tabContent.length; tabcnt++) {
                        tabContent[tabcnt].style.height = dynamicHeight;
                    }
                } else {
                    tabContent.forEach(item => {
                        item.style.height = dynamicHeight;
                    });
                }
                mapContent.style.height = dynamicHeight;
            }
         }            
    }

    
    getCenter() {        
        const { list, getLatitude, getLongitude, indexOfFocus } = this.props;
        const length = list && list.length ? list.length : 0;
        if (list && length > 0) {
            const centerIndex = indexOfFocus && indexOfFocus > -1 && indexOfFocus < list.length ? indexOfFocus : 0;
            const latitude1 = getLatitude(list[centerIndex]);
            const longitude1 = getLongitude(list[centerIndex]);            
            return { lat: latitude1, lng: longitude1 };

            //let totalLatitude = 0;
            //let totalLongitude = 0;
            //list.forEach(item => {
            //    totalLatitude += getLatitude(item);
            //    totalLongitude += getLongitude(item);
            //});

            //return { lat: totalLatitude / length, lng: totalLongitude / length };
        }
        else {
            // Defaulting to Dallas in case nothing is returned from Provider/Location
            return { lat: 32.74996881666311, lng: -96.82336862454478 };
        }
    }

    indexOfMarker(marker) {
        const myMarkers = this.state.myMarkers;
        for (let i = 0; i < myMarkers.length; i++) {
            if (myMarkers[i].props.id === marker.id) {
                return i;
            }
        }
        return -1;
    }

    updateMarker(marker) {
        const myMarkers = this.state.myMarkers;
        let selectedMarker = this.state.selectedMarker;

        if (selectedMarker) {
            selectedMarker.props.icon.url = defaultMarkerUrl;
            myMarkers.push(selectedMarker);
        }

        selectedMarker = null;
        let deselectedMarker = null;
        if (marker) {
            const selectedIndex = this.indexOfMarker(marker);
            if (selectedIndex > -1) {
                const markerProps = myMarkers.splice(selectedIndex, 1)[0].props;
                markerProps.icon.url = selectedMarkerUrl;
                const deselectedMarkerProps = { ...markerProps, icon: { ...markerProps.icon, url: defaultMarkerUrl } };
                const id = this.props.getId(marker.item);
                selectedMarker = <OurMarker key={id} {...markerProps} />;
                deselectedMarker = <OurMarker key={id} {...deselectedMarkerProps} />;
            }
        }

        this.setState({
            myMarkers: myMarkers,
            activeMarker: marker,
            selectedMarker: selectedMarker,
            deselectedMarker: deselectedMarker
        });
    }

    onMarkerClick = (props, marker) => {
        if (this._isMounted && marker !== this.state.selectedMarker) {
            this.updateMarker(marker);
            if (this.props.onItemSelected) {
                this.props.onItemSelected(marker.item);
            }
        }
    };

    onMarkerMouseover = (props, marker) => {
        if (marker !== this.state.activeMarker) {
            this.setState({ activeMarker: marker });
            this.mouseOverMarker = true;
        }
        else {
            this.mouseOverMarker = false;
        }
    }

    onMarkerMouseout = () => {
        if (this.state.activeMarker && !this.mouseOverMarker) {
            this.setState({ activeMarker: null });
        }
        this.mouseOverMarker = false;
    }

    onMapClick = (props) => {
        if (this._isMounted) {
            this.updateMarker(null);
            if (props.onItemDeselected) {
                props.onItemDeselected();
            }
        }
    }

    reverseGeocoding(lat, lng, success) {
        if (typeof window !== 'undefined' && window.google.maps) {
            let latlng = { lat: lat, lng: lng };
            let geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: latlng }, function (results, status) {
                if (status === 'OK') {
                    console.log(results[0]);
                    if (results[0].address_components && results[0].address_components.length > 0) {
                        let zipCode = results[0].address_components[results[0].address_components.length - 1];
                        if (zipCode) {
                            success(zipCode.short_name);
                        }
                    }
                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                }
            });
        } else {
            console.log("Window object is not defined");
        }
    }

    onMapReady = (mapProps, map) => {
        this.map = map;
        const { google, searchHereButton } = this.props;
        if (searchHereButton && this.searchHereControl) {
            this.searchHereControl.index = 1;
            this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(this.searchHereControl);            
        }
        if (searchHereButton)
            this.handleMapHeight();
        
        this.zoomSetByUser = false;
    };

    onMapDragend() {
        if (!this.props.searchHereButton) return;
        this.showSearchHere();
    }

    /* the issue is we want to show search here only when user zooms
       explicitly by using zoom in /out buttons. But this event gets 
       called on fitBounds and some other internal methods of map api 
       too, so want to avoid this method by using a flag this.zoomSetByUser. 
       But this is also NOT FULL-PROOF solution as there is no way to differentiate between manual zoom and the one triggered by Map API.
       More here : https://stackoverflow.com/questions/10097647/how-to-listen-for-user-generated-zoom-in-google-maps */

    onZoomChanged() {
        if (!this.zoomSetByUser) {
            this.zoomSetByUser = true;
            return;
        }
        if (!this.props.searchHereButton) return;
        this.showSearchHere(); 
    }

    searchHere() {
        const location = this.map.getCenter();
        const { google } = this.props;
        const bounds = this.map.getBounds();
        // Calculate NorthWest point so we can work out height 
        const northWest = new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getSouthWest().lng());
        const boundsHeight = google.maps.geometry.spherical.computeDistanceBetween(northWest, bounds.getSouthWest());
        const boundsWidth = google.maps.geometry.spherical.computeDistanceBetween(northWest, bounds.getNorthEast());
        const width = boundsWidth / 2;
        const height = boundsHeight / 2;
        //converts to miles
        const distance = Math.round((height >= width ? height : width) * 0.000621371192);
        const mapZoom = this.map.getZoom();
        // Call API to get results on the basis of mapped area
        if (this.props.getMappedAreaSearchResults) {
            this.setState({
                mappedAreaLocation: {
                    latitude: location.lat(),
                    longitude: location.lng()
                },
                mapBounds: bounds
            });
            this.props.getMappedAreaSearchResults({
                distance,
                location: {
                    latitude: location.lat(),
                    longitude: location.lng()
                },
                bounds,
                selectedRadius : this.props.distance
            });
            this.zoomSetByUser = true;  // So that next time whenever there is an explicit zoom , we show Search Here button.
            //if (mapZoom) this.setState({ zoom: mapZoom }, () => { this.zoomSetByUser = false;});            
            this.hideSearchHere();
            this.props.setFitBounds(false);
        }       
    }

    hideSearchHere() {
        if (this.props.setMainSearch)
            this.props.setMainSearch(true);
    }

    showSearchHere() {
        if (this.props.setMainSearch)
            this.props.setMainSearch(false);
    }

    render() {
        const { myMarkers, activeMarker, selectedMarker, deselectedMarker, zoom, mappedAreaLocation } = this.state;
        const { google, highlightSelectedItem, getDisplayValue, zoomOut, searchHereButton, hideSearchHere, isMappedArea } = this.props;       
        const initialCenter = !isMappedArea || !mappedAreaLocation ? this.getCenter() : { lat: mappedAreaLocation.latitude, lng: mappedAreaLocation.longitude };         
        return (
            <>
                <Map google={google} zoom={searchHereButton ? zoom : zoomOut ? 7 : 10}
                    initialCenter={initialCenter}  styles={mapStyles}
                    zoomControlOptions={{ position: google.maps.ControlPosition.RIGHT_TOP }}
                    onMouseout={this.onMouseout} onClick={() => this.onMapClick(this.props)} onReady={this.onMapReady} onDragend={this.onMapDragend} onZoomChanged={this.onZoomChanged}
                >
                    {myMarkers}
                    {selectedMarker && (highlightSelectedItem ? selectedMarker : deselectedMarker)}
                    <InfoWindow
                        marker={activeMarker}
                        visible={activeMarker !== null}
                    >
                        <div id="iwc">
                            {activeMarker && <div className="mapPin-label">{getDisplayValue(activeMarker.item)}</div>}
                        </div>
                    </InfoWindow>
                </Map>
                {
                    !hideSearchHere && this.props.searchHereButton &&
                    <div  ref={(ref) => { this.searchHereControl = ref; }} onClick={this.searchHere} title='Click to SEARCH HERE' className="search-here-button">
                        <div>
                            SEARCH THIS AREA
                            </div>
                    </div>
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        googleMapKey: state.session.serverData.googleMapKey
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateCurrentLocationZipCode: (zipCode) => dispatch({
            type: types.CURRENT_LOCATION_ZIPCODE, payload: { currentLocationZipCode: zipCode }
        })
    };
};

const GoogleMapMainComp = GoogleApiWrapper((props) => ({
    apiKey: props.googleMapKey,
    libraries: ["places", "geometry"]
}))(GoogleMapMain);

export default connect(mapStateToProps, mapDispatchToProps)(GoogleMapMainComp);
